// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import {
    GreifOrderUploadDocumentState,
    GreifOrderUploadState,
} from "@store/Framework/Store/Greif/Components/GreifOrderUpload/GreifOrderUploadState";
import { Draft } from "immer";

const initialState: GreifOrderUploadState = {
    documents: [],
    document: { data: "", fileName: "" },
    errors: "",
    errorMessage: "",
    isUploading: false,
    isBadFile: false,
    uploadLimitExceeded: false,
    errorsModalIsOpen: false,
    canSubmitOrder: false,
    fileUploaded: false,
    isSubmitting: false,
    orderSubmitted: false,
    webOrderNumber: "",
    isCreatingCart: false,
    cartIsCreated: false,
    creationFailed: false,
};

const actions = {
    "Greif/ComponentsReducer/GreifOrderUpload/BeginUploadAndValidateFile": (draft: Draft<GreifOrderUploadState>) => {
        draft.isUploading = true;
        draft.errorMessage = initialState.errorMessage;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/FailedToUploadAndValidateFile": (
        draft: Draft<GreifOrderUploadState>,
        action: { error: string | undefined },
    ) => {
        draft.isUploading = false;
        draft.errorMessage = action.error;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/CompleteUploadAndValidateFile": (draft: Draft<GreifOrderUploadState>) => {
        draft.isUploading = false;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/DispatchSuccessfulValidationResults": (
        draft: Draft<GreifOrderUploadState>,
        action: { errors: string; document: GreifOrderUploadDocumentState },
    ) => {
        draft.errors = action.errors;
        draft.document = action.document;
        draft.fileUploaded = true;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/SetCanSubmitOrder": (draft: Draft<GreifOrderUploadState>) => {
        draft.canSubmitOrder = true;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/SetErrorsModalIsOpen": (
        draft: Draft<GreifOrderUploadState>,
        action: { parameter: { errorsModalIsOpen: boolean } },
    ) => {
        draft.errorsModalIsOpen = action.parameter.errorsModalIsOpen;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/SetIsBadFile": (
        draft: Draft<GreifOrderUploadState>,
        action: { parameter: { isBadFile: boolean } },
    ) => {
        draft.isBadFile = action.parameter.isBadFile;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/SetErrorMessage": (
        draft: Draft<GreifOrderUploadState>,
        action: { parameter: { errorMessage: string } },
    ) => {
        draft.errorMessage = action.parameter.errorMessage;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/SetUploadLimitExceeded": (
        draft: Draft<GreifOrderUploadState>,
        action: { parameter: { uploadLimitExceeded: boolean } },
    ) => {
        draft.uploadLimitExceeded = action.parameter.uploadLimitExceeded;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/ClearUploadedFileStatus": (draft: Draft<GreifOrderUploadState>) => {
        draft.errors = initialState.errors;
        draft.document = initialState.document;
        draft.canSubmitOrder = initialState.canSubmitOrder;
        draft.fileUploaded = initialState.fileUploaded;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/ClearSubmittedUploadedOrder": (draft: Draft<GreifOrderUploadState>) => {
        draft.cartIsCreated = initialState.cartIsCreated;
        draft.webOrderNumber = initialState.webOrderNumber;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/BeginSubmitUploadedOrder": (draft: Draft<GreifOrderUploadState>) => {
        draft.isSubmitting = true;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/CompleteSubmitUploadedOrder": (draft: Draft<GreifOrderUploadState>) => {
        draft.isSubmitting = false;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/BeginCreateCartUpload": (draft: Draft<GreifOrderUploadState>) => {
        draft.isCreatingCart = true;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/DispatchSuccessfulCreateCartResults": (
        draft: Draft<GreifOrderUploadState>,
        action: { webOrderNumber: string },
    ) => {
        draft.cartIsCreated = true;
        draft.webOrderNumber = action.webOrderNumber;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/FailedToCreateCartUpload": (draft: Draft<GreifOrderUploadState>) => {
        draft.isCreatingCart = false;
        draft.creationFailed = true;
    },
    "Greif/ComponentsReducer/GreifOrderUpload/CompleteCreateCartUpload": (draft: Draft<GreifOrderUploadState>) => {
        draft.isCreatingCart = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsOrderUploadActions = Parameters<typeof reducer>[1];
export default reducer;
